/**
 * 检测当前是否为 PC 环境
 *
 * 判断逻辑：
 * 1. 检查操作系统标识
 *    - Windows NT
 *    - Macintosh
 *    - Linux (不包含 Android)
 *    - X11
 * 2. 排除移动设备
 *    - 包含 Android 的 Linux 设备为移动设备
 *
 * @returns {boolean} 如果是 PC 环境返回 true，否则返回 false
 *
 * @example
 * ```ts
 * if (isPC()) {
 *   enableMouseEvents();
 * } else {
 *   enableTouchEvents();
 * }
 * ```
 */
export function isPC(): boolean {
  try {
    if (!navigator?.userAgent) {
      return true; // 服务端环境默认为 PC
    }

    const ua = navigator.userAgent.toLowerCase();

    // 移动设备标识
    if (ua.includes("android") || ua.includes("mobile")) {
      return false;
    }

    // PC 操作系统标识
    return (
      ua.includes("windows nt") ||
      ua.includes("macintosh") ||
      (ua.includes("linux") && !ua.includes("android")) ||
      ua.includes("x11")
    );
  } catch (error) {
    console.warn("检测PC环境失败:", error);
    return false;
  }
}
